/**
 * Created by Mikhail Menshenin on 09.07.2024
 */

const VillageView = cc.Node.extend({
    ctor: function (village) {
        this._super();
        this.setAnchorPoint(0.5, 0.5);
        this.setAlignment({ x: { align: "center" }, y: { align: "center" } });

        this.village = village;

        this.hutViews = village.huts.map((hut) => {
            const hutView = new HutView(hut);
            this.addChild(hutView);
            return hutView;
        });

        this.crossViews = village.crosses.map((cross) => {
            const crossView = new CrossView(cross);
            this.addChild(crossView);
            return crossView;
        });

        this.movingNode = new cc.Node();
        this.addChild(this.movingNode);

        village.on("assault", this.showAssaultAnimation.bind(this), this);
        village.on("defense", this.showDefenseAnimation.bind(this), this);
    },

    showAnimation: function (silent) {
        this.setVisible(true);
        if (silent) {
            return;
        }

        this.runAction(new cc.Sequence(
            new cc.DelayTime(0.7),
            new cc.CallFunc(() => {
                cleverapps.audio.playSound(bundles.main.urls.objects);
            }),
            new cc.DelayTime(0.2),
            new cc.CallFunc(() => {
                if (this.village.isStateAttack()) {
                    cleverapps.audio.playSound(bundles.main.urls.aim);
                }
            })
        ));
        this.hutViews.forEach((hutView) => {
            if (!this.village.isStateBuild()) {
                hutView.spawn();
            }
        });
    },

    showAssaultAnimation: function (f) {
        cleverapps.audio.playSound(bundles.main.urls.lightning);

        this.runAction(
            new cc.Sequence(
                new cc.DelayTime(0.3),
                new cc.CallFunc(f)
            )
        );
    },

    showDefenseAnimation: function (f) {
        const spine = new cleverapps.Spine(bundles.village.jsons.village_attack_json);
        spine.setAlignment({ x: { align: "center" }, y: { align: "center" } });
        this.addChild(spine);

        spine.runAction(
            new cc.Sequence(
                new cc.PlaySound(bundles.main.urls.lightning_shield),
                new cc.SpineAction(spine, "defend"),
                new cc.CallFunc(() => {
                    spine.removeFromParent(true);
                    f();
                })
            )
        );
    },

    onHide: function () {
        this.village.changeUpgradeTools(false);
    },

    checkTouch: function (touch, isDouble) {
        if (this.village.counter.isActive()) {
            return false;
        }
        let touched = false;

        this.hutViews.forEach((hutView) => {
            touched = touched || hutView.checkClick(touch, isDouble);
        });

        this.crossViews.forEach((crossView) => {
            touched = touched || crossView.checkClick(touch);
        });

        if (!touched && !isDouble) {
            this.village.changeUpgradeTools(false);
        }

        return touched;
    }
});
